import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_AGENTS_REQUEST,
  CREATE_AGENT_REQUEST,
  UPDATE_AGENT_REQUEST,
  DELETE_AGENT_REQUEST,
  fetchAgentsSuccess,
  fetchAgentsFailure,
  createAgentSuccess,
  createAgentFailure,
  updateAgentSuccess,
  updateAgentFailure,
  deleteAgentSuccess,
  deleteAgentFailure,
} from '../actions/agentAction';
import { notification } from 'antd';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/agents`;
const getAuthToken = () => localStorage.getItem('authToken');

function* fetchAgentsSaga(action) {
  try {
    const token = getAuthToken();
    const { page = 1, limit = 1, search = '', model } = action.payload || {}; // Added model here
    const response = yield call(axios.get, API_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit, search, model }, // Added model to params
    });

    yield put(fetchAgentsSuccess(response.data));
  } catch (error) {
    yield put(fetchAgentsFailure(error.message));
  }
}

function* createAgentSaga(action) {
  try {
    const token = getAuthToken();
    const response = yield call(axios.post, API_BASE_URL, action.payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(createAgentSuccess(response.data));
    notification.success({
      key: "agent_store",
      message: "Agent Created Successfully",
    });
  } catch (error) {
    yield put(createAgentFailure(error.message));
  }
}

function* updateAgentSaga(action) {
  const { agentId, agentData } = action.payload;
  try {
    const token = getAuthToken();
    const response = yield call(axios.put, `${API_BASE_URL}/${agentId}`, agentData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(updateAgentSuccess(response.data));
    notification.success({
      key: "agent_store",
      message: "Agent Updated Successfully",
    });
  } catch (error) {
    yield put(updateAgentFailure(error.message));
  }
}

function* deleteAgentSaga(action) {
  try {
    const token = getAuthToken();
    yield call(axios.delete, `${API_BASE_URL}/${action.payload}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(deleteAgentSuccess(action.payload));
  } catch (error) {
    yield put(deleteAgentFailure(error.message));
  }
}

export default function* agentSaga() {
  yield takeLatest(FETCH_AGENTS_REQUEST, fetchAgentsSaga);
  yield takeLatest(CREATE_AGENT_REQUEST, createAgentSaga);
  yield takeLatest(UPDATE_AGENT_REQUEST, updateAgentSaga);
  yield takeLatest(DELETE_AGENT_REQUEST, deleteAgentSaga);
}
